import { useEffect, useReducer } from 'react'
import api, { INeighborhoodDetails } from '@api'
import { Toaster } from '@ui'
import { ApolloError } from 'apollo-boost'
import { useShouldReload } from '@hooks/reloadContext'

enum Actions {
  DETAILS,
}

interface Details {
  type: Actions.DETAILS
  item: INeighborhoodDetails
}

type RootAction = Details

interface IState {
  item: INeighborhoodDetails | null
  isLoading: boolean
}

export interface UseNeighborhoodHook extends IState {
  id: string
}

function reducer(state: IState, action: RootAction): IState {
  switch (action.type) {
    case Actions.DETAILS:
      return {
        ...state,
        isLoading: false,
        item: action.item,
      }

    default:
      return state
  }
}

export default function useNeighborhood(neighborhoodId: string): UseNeighborhoodHook {
  const [state, dispatch] = useReducer(reducer, {
    item: null,
    isLoading: true,
  })

  const shouldReload = useShouldReload()

  useEffect(() => {
    api.neighborhood
      .details(neighborhoodId)
      .then((item) => {
        dispatch({
          type: Actions.DETAILS,
          item,
        })
      })
      .catch((error: ApolloError) => Toaster.fail({ error }))
  }, [shouldReload.neighborhoods, neighborhoodId])

  return {
    ...state,
    id: neighborhoodId,
  }
}
